module.exports = __webpack_public_path__ + "static/icon-surprise.df759350.svg";